import { FORM_TYPE_CREATE_DIRECT_FLOW } from 'js/constants/formTypes';
import { useChangeDetection as useGenericChangeDetection } from 'new/components/flows/hooks/useChangeDetection';

export const useChangeDetection = () => {
  return useGenericChangeDetection(FORM_TYPE_CREATE_DIRECT_FLOW);
};
